import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { AngularMaterialModule } from '@app/shared/modules/angular-material.module';
import { DynamicPipe } from '@app/shared/pipes/dynamic-pipe';
import { ReportLinkFieldName } from '@app/pages/report-link/report-link.constant';

@Component({
  selector: 'app-report-link-data-grid-cell',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AngularMaterialModule, CommonModule, TranslateModule, DynamicPipe],
  template: `
  @if(data[field] === ''){
    <div></div>
  }
  @else {
    @switch (field) {
      @case (reportLinkFieldName.reportUrl){
        <a [href]="data[field]" target="_blank">{{'ml_143965' | translate}}</a>
      }
      @default {
        <div [innerHtml]="data[field] | dynamicPipe: column.pipe: column.pipeArgs"></div>
      }
    }
  }

  `
})
export class ReportLinkDataGridCell implements OnInit {
  @Input() data: any;
  @Input() field: string;
  @Input() column: any;

  reportLinkFieldName = ReportLinkFieldName;

  constructor() { }

  ngOnInit() { }


}
